const SESSION_DATA_KEY = {
  Root: 'session-data',
  Session: 'session',
  Settings: 'settings',
  Products: 'products',
  Versions: 'versions',
  ProductDetail: 'product-detail',
  ProductTimeline: 'product-timeline',
  VersionDetail: 'version-detail',
  Collabs: 'collabs',
  Paths: 'paths',
} as const;

const SESSION_DATA_ROOT_KEY = [SESSION_DATA_KEY.Root] as const;

export function createSessionDataKeys() {
  return {
    all: SESSION_DATA_ROOT_KEY,
    session: (sessionId: string) => keyedSessionDataPath(SESSION_DATA_KEY.Session, sessionId),
    settings: (sessionId: string) => keyedSessionDataPath(SESSION_DATA_KEY.Settings, sessionId),
    products: (sessionId: string) => keyedSessionDataPath(SESSION_DATA_KEY.Products, sessionId),
    versions: versionSessionDataPath,
    productDetail: (sessionId: string, productId: string) =>
      keyedSessionProductPath(SESSION_DATA_KEY.ProductDetail, sessionId, productId),
    productTimeline: (sessionId: string, productId: string) =>
      keyedSessionProductPath(SESSION_DATA_KEY.ProductTimeline, sessionId, productId),
    versionDetail: (sessionId: string, versionId: string) =>
      keyedSessionProductPath(SESSION_DATA_KEY.VersionDetail, sessionId, versionId),
    collabs: (sessionId: string, productId: string) =>
      keyedSessionProductPath(SESSION_DATA_KEY.Collabs, sessionId, productId),
    paths: (sessionId: string) => keyedSessionDataPath(SESSION_DATA_KEY.Paths, sessionId),
  };
}

function keyedSessionDataPath(segment: string, sessionId: string) {
  return [...SESSION_DATA_ROOT_KEY, segment, sessionId] as const;
}

function keyedSessionProductPath(segment: string, sessionId: string, productId: string) {
  return [...SESSION_DATA_ROOT_KEY, segment, sessionId, productId] as const;
}

function versionSessionDataPath(
  sessionId: string,
  productId: string,
  limit?: number,
  versionsSignature?: string,
) {
  return [
    ...SESSION_DATA_ROOT_KEY,
    SESSION_DATA_KEY.Versions,
    sessionId,
    productId,
    limit ?? null,
    versionsSignature ?? '',
  ] as const;
}
